import { MarketplaceAnalyticsContext } from '@atlassian/mpac-analytics';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';

const AgentsPageCodeSplit = lazyForPaint(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "chunk-agentsPage" */ './components/AgentsPage'
    )
);

const RouteHandler = () => {
  return (
    <BaseRouteHandler scrollToTopOnPathChange includePartnerQuickLinks>
      <MarketplaceAnalyticsContext properties={{ source: 'agents_page' }}>
        <LazySuspense fallback={<div />}>
          <AgentsPageCodeSplit />
        </LazySuspense>
      </MarketplaceAnalyticsContext>
    </BaseRouteHandler>
  );
};

export default RouteHandler;
